import gql from 'graphql-tag'

export const upcomingEventsQuery = gql`
  query UpcomingEvents {
    events(upcomingOnly: true, limitToUserGroups: true) {
      nodes {
        id
        name
        startTime
      }
    }
  }
` 